module.exports = __webpack_public_path__ + "img/j5.0337ecf1.png";